import React, { useEffect, useState, useRef, useMemo } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// // import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  // setShowShareBtn,
  // haUserId,
  haAccessToken,
  haMemberMissionId,
  setCompletionMessage,
  setIsDkabio,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  const noneAnswersRef = useRef({})
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '0900000000',
    alert: '資訊錯誤，請聯繫 HR 以更新問卷狀態',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)
  agreeSurvey.onCurrentPageChanged.add(function (survey, options) {
    // 切換頁面時滾動到頂部
    window.scrollTo(0, 0)
  })
  useEffect(() => {
    setCompletionMessage(
      `<h4 style="text-align:center">感謝您的填寫！</h4><p>您將可於 HA! 健康 App 內查看您的 DKABio 智慧健康風險分析報告。若您有任何問題，隨時歡迎向浚鴻數據的工作人員直接詢問。</p>`
    )
  }, [])

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列
  // const visibleIfConditionsInit = {
  //   q1: '{q0} = 0',
  // }

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [19]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q2', 'q11', 'q15']
  const pageBreakQuestions = null
  const triggersConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    // serial_num,
    bringOptionsMapRef,
    // haUserId,
    haAccessToken,
    haMemberMissionId,
  })

  // const newSurvey = new Model(convertedSurvey)
  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    const survey = new Model(convertedSurvey)

    // 初始化 choiceIndexMapRef
    const initializeChoiceIndexMap = (questionName) => {
      const question = survey.getQuestionByName(questionName)
      if (question) {
        // 初始化 choiceIndexMapRef
        if (!choiceIndexMapRef.current[questionName]) {
          // 建立基本的選項映射
          const choiceMap = {}

          // 處理一般選項
          if (question.choices) {
            question.choices.forEach((choice, index) => {
              choiceMap[choice.value] = index
            })
          }

          // 處理 none 選項
          if (question.showNoneItem) {
            const noneIndex = question.choices ? question.choices.length : 0
            choiceMap['none'] = noneIndex

            // 同時初始化 noneAnswers
            noneAnswersRef.current[questionName] = {
              noneIndex: noneIndex,
            }
          }

          choiceIndexMapRef.current[questionName] = choiceMap
        }

        // 初始化 choicesOrderRef
        if (!choicesOrderRef.current[questionName]) {
          let order = []

          // 添加一般選項
          if (question.choices) {
            order = question.choices.map((choice) => choice.value)
          }

          // 添加 none 選項到順序中
          if (question.showNoneItem) {
            const noneIndex = order.length
            order.push(noneIndex)
          }

          choicesOrderRef.current[questionName] = order
        }
      } else {
        choiceIndexMapRef.current[questionName] = {}
        choicesOrderRef.current[questionName] = []
      }
    }

    // 設定預設值之前先初始化必要的資料結構
    ;[...Array(17)]
      .map((_, i) => `q${i}`)
      .forEach((questionName) => {
        initializeChoiceIndexMap(questionName)
      })

    // 在 onValueChanged 時設定時間戳，而不是在這裡
    survey.onValueChanged.add((sender, options) => {
      // 這會觸發 useSubmitAnswers 中的 handleValueChanged
      survey.setValue(options.name, options.value)
    })

    // 設定預設值
    survey.setValue('q0', haAccessToken)
    survey.setValue('q1', 1)
    survey.setValue('q2', '1975-03-13')
    survey.setValue('q3', '157.1')
    survey.setValue('q4', '69.8')
    survey.setValue('q5', '84')
    survey.setValue('q6', '115')
    survey.setValue('q7', '6')
    survey.setValue('q8', 1)
    survey.setValue('q9', 0)
    survey.setValue('q10', 2)
    survey.setValue('q11', 1)
    survey.setValue('q12', [9, 10])
    survey.setValue('q13', [9, 10])
    survey.setValue('q14', ['none'])
    survey.setValue('q15', [9, 11])
    survey.setValue('q16', ['none'])
    // console.log('survey', survey)
    console.log('choiceIndexMapRef', choiceIndexMapRef)
    console.log('choicesOrderRef', choicesOrderRef)
    return survey
  }, [convertedSurvey])
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555
  }

  const canShowPrevButtonPages = null

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    // setShowShareBtn,
    bringOptionsMapRef,
    haAccessToken,
    haMemberMissionId,
    setIsDkabio,
  })

  // const completedPageElement = document.querySelector('.sd-completedpage')
  // useEffect(() => {
  //   if (completedPageElement) {
  //     setShowShareBtn(true)
  //     console.log('5566')
  //   }
  // }, [newSurvey])

  return (
    <>
      {surveyModel ? (
        <>
          <Survey model={surveyModel} />
        </>
      ) : myAgreeJson ? (
        <>
          <Survey model={agreeSurvey} />
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
